import { JukeboxTypes } from '../constants/jukeboxConstants';

const startPlay = (videoId) => ({
    type: JukeboxTypes.JUKEBOX_PLAY_YT,
    videoId, 
});

const stopPlay = (videoId) => ({
    type: JukeboxTypes.JUKEBOX_STOP_YT,
    videoId, 
});

export default {
    startPlay,
    stopPlay
};